module.exports = __webpack_public_path__ + "static/features-3-e30bda8c64d884d7fa41cb7a0b63f010.svg";